import {getEotrans} from "@/service/e-grid-service";

export default {
    state() {
        return {
            eotrans: [],
        }
    },
    mutations: {
        setEosrcEotransDict(state, {dictName, data}) {
            state[dictName] = data;
        }
    },
    actions: {
        async loadEosrcEotrans({commit}, payload) {
            const data = await getEotrans(payload);
            if (data && data.result) {
                commit('setEosrcEotransDict', {dictName: 'eotrans', data: data.data !== null ? data.data : []})
            }
        }
    }
}